/**
 * Lab Page - Standalone admin page for ElevenLabs TTS.
 * Renders LabTab with admin layout (sidebar, header).
 */
import React, { useState, useEffect } from 'react';
import AdminSidebar from './AdminSidebar';
import DashboardHeader from './DashboardHeader';
import LabTab from './LabTab';
import { authAPI } from '../services/api';
import { useSidebar } from '../contexts/SidebarContext';
import './LabTab.css';
import './Dashboard.css';

interface LabPageProps {
  onLogout?: () => void;
  userEmail?: string;
}

const LabPage: React.FC<LabPageProps> = ({ onLogout, userEmail }) => {
  const { isCollapsed } = useSidebar();
  const [userInfo, setUserInfo] = useState({
    email: userEmail || '',
    organization: 'NAATI',
    first_name: ''
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profile = await authAPI.getProfile();
        setUserInfo({
          email: profile.email || userEmail || '',
          organization: profile.organization || 'NAATI',
          first_name: profile.first_name || ''
        });
      } catch (err) {
        console.error('Failed to fetch user profile:', err);
      }
    };
    fetchUserProfile();
  }, [userEmail]);

  const handleLogout = () => {
    if (onLogout) onLogout();
  };

  return (
    <div className={`dashboard ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <AdminSidebar />
      <div className="dashboard-main">
        <DashboardHeader
          userEmail={userInfo.email}
          organization={userInfo.organization}
          onLogout={handleLogout}
        />
        <div className="dashboard-content">
          <div className="dashboard-content-inner">
            <div className="dashboard-welcome">
              <h1 className="dashboard-title">Lab</h1>
              <p className="dashboard-subtitle">Generate audio with ElevenLabs TTS for Structural Segments and Dialogue Categories</p>
            </div>
            <LabTab />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabPage;
